import { render, staticRenderFns } from "./Classification.vue?vue&type=template&id=0e5429ac&scoped=true&"
import script from "./Classification.vue?vue&type=script&lang=js&"
export * from "./Classification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e5429ac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e5429ac')) {
      api.createRecord('0e5429ac', component.options)
    } else {
      api.reload('0e5429ac', component.options)
    }
    module.hot.accept("./Classification.vue?vue&type=template&id=0e5429ac&scoped=true&", function () {
      api.rerender('0e5429ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Affiliates/Dashboard/Classification.vue"
export default component.exports